module.exports = __webpack_public_path__ + "resources/img/img_appen_data2.61f49bbe444aca3ecf8d6a67e3ad8b11.png";